import { configureApiEntity } from '../adapter';
import { schema } from 'normalizr';

const customerSchema = new schema.Entity('customer');

export const customers = configureApiEntity('CUSTOMERS', 'customers', customerSchema);
